<script>
  import { Link, navigate } from "svelte-routing";
  import { onMount } from "svelte";

  let login_status = "";
  let login_status_data = "";
  const API_END_POINT = END_POINT;
  const api_url = API_END_POINT + "createaccount.php";

  onMount(() => {
    window.scrollTo(0, 0);
    const loggedin_user = localStorage.getItem("us");

    if (loggedin_user != null && !loggedin_user.isEmpty()) {
      navigate("/");
    }
  });

  function preventDefault() {
    fetchdata();
  }

  async function countandredirecttohome() {
    await new Promise((resolve) => setTimeout(resolve, 4000));
    navigate("/");
  }

  async function fetchdata() {
    const name = document.querySelector("#name").value;
    const phone = document.querySelector("#phonenumber").value;
    const dob = document.querySelector("#dob").value;
    const pass = document.querySelector("#password").value;
    const pass2 = document.querySelector("#password2").value;
    const address = document.querySelector("#address").value;
    const state = document.querySelector("#state").value;
    const pincode = document.querySelector("#pincode").value;

    const response = await fetch(api_url, {
      method: "POST",
      body: JSON.stringify({
        uphone: phone,
        upass: pass,
        uname: name,
        upass2: pass2,
        udob: dob,
        address: address,
        state: state,
        pincode: pincode,
      }),
    });

    const data = await response.json();

    const status = data.status;
    const status_data = data.content;

    login_status = status;
    login_status_data = status_data;

    if (status === "pass") {
      localStorage.setItem("us", phone);
      countandredirecttohome();
    }
  }
</script>

<svelte:head>
  <title>Create New Account</title>
</svelte:head>

<main class="main-wrapper">
  <!-- ...:::Start User Event Section:::... -->
  <div class="header-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="header-area">
        <div class="header-top-area header-top-area--style-1">
          <ul class="event-list justify-content-center">
            <li class="list-item">
              <h5 class="title text-center">
                <a href="/">
                  <img
                    src="./logo.png"
                    alt="veeranfashions"
                    width="100px"
                    height="100px"
                  /></a
                >
                <br />Veeran Fashions
              </h5>
            </li>
          </ul>
        </div>
      </div>
      <!-- End User Event Area -->
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->

  <!-- ...:::Start Login Section:::... -->
  <div class="login-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="login-wrapper">
        <div class="section-content">
          <h1 class="title">Create New Account</h1>
          <p>An account is mandatory for using this app</p>
        </div>
        {#if login_status === "fail"}
          <div class="pt-3">
            <div class="alert alert-danger" role="alert">
              {login_status_data}
            </div>
          </div>
        {/if}
        {#if login_status === "pass"}
          <div class="pt-3">
            <div class="alert alert-success" role="alert">
              {login_status_data}
            </div>
          </div>
        {/if}
        <form
          on:submit|preventDefault={preventDefault}
          class="default-form-wrapper"
        >
          <ul class="default-form-list">
            <li class="single-form-item">
              <label for="name" class="visually-hidden">Name</label>
              <input
                type="text"
                id="name"
                placeholder="Your Name"
                maxlength="25"
                required
              />
              <span class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-person-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                  />
                </svg>
              </span>
            </li>
            <li class="single-form-item">
              <label for="phonenumber" class="visually-hidden"
                >phonenumber</label
              >
              <input
                type="tel"
                id="phonenumber"
                maxlength="10"
                placeholder="Phone Number"
                required
              />
              <span class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-telephone-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                  />
                </svg>
              </span>
            </li>
            <li class="single-form-item">
              <label for="date" class="visually-hidden">dob</label>
              <input
                type="text"
                id="dob"
                placeholder="Ex : Date of birth : dd/mm/yyyy"
                maxlength="10"
                required
              />
              <span class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-calendar3-event-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2 0a2 2 0 0 0-2 2h16a2 2 0 0 0-2-2H2zM0 14V3h16v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12-8a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"
                  />
                </svg>
              </span>
            </li>

            <label for="address" class="form-label">Address</label>
            <li class="single-form-item">
              <textarea
                type="text"
                id="address"
                class="form-control"
                placeholder="Enter Your Address [You can Change it Anytime after Account Creation.] "
                rows="3"
                required
              />
            </li>

            <label for="state" class="form-label">State</label>
            <li class="single-form-item">
              <select name="state" id="state" class="form-control">
                <option value="Tamil Nadu" selected>Tamil Nadu</option>
                <option value="Pondicherry">Pondicherry</option>
                <option value="Kerala">Kerala</option>
                <option value="Karnataka">Karnataka</option>
                <option value="Andaman and Nicobar Islands"
                  >Andaman and Nicobar Islands</option
                >
                <option value="Andhra Pradesh">Andhra Pradesh</option>
                <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                <option value="Assam">Assam</option>
                <option value="Bihar">Bihar</option>
                <option value="Chandigarh">Chandigarh</option>
                <option value="Chhattisgarh">Chhattisgarh</option>
                <option value="Dadra and Nagar Haveli"
                  >Dadra and Nagar Haveli</option
                >
                <option value="Daman and Diu">Daman and Diu</option>
                <option value="Delhi">Delhi</option>
                <option value="Goa">Goa</option>
                <option value="Gujarat">Gujarat</option>
                <option value="Haryana">Haryana</option>
                <option value="Himachal Pradesh">Himachal Pradesh</option>
                <option value="Jammu and Kashmir">Jammu and Kashmir</option>
                <option value="Jharkhand">Jharkhand</option>
                <option value="Lakshadweep">Lakshadweep</option>
                <option value="Madhya Pradesh">Madhya Pradesh</option>
                <option value="Maharashtra">Maharashtra</option>
                <option value="Manipur">Manipur</option>
                <option value="Meghalaya">Meghalaya</option>
                <option value="Mizoram">Mizoram</option>
                <option value="Nagaland">Nagaland</option>
                <option value="Orissa">Orissa</option>
                <option value="Punjab">Punjab</option>
                <option value="Rajasthan">Rajasthan</option>
                <option value="Sikkim">Sikkim</option>
                <option value="Tripura">Tripura</option>
                <option value="Uttaranchal">Uttaranchal</option>
                <option value="Uttar Pradesh">Uttar Pradesh</option>
                <option value="West Bengal">West Bengal</option>
              </select>
            </li>

            <li class="single-form-item">
              <label for="date" class="visually-hidden">Pincode</label>
              <input
                type="tel"
                id="pincode"
                maxlength="6"
                placeholder="Enter Pincode"
                required
              />
              <span class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-geo-alt-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                  />
                </svg>
              </span>
            </li>

            <li class="single-form-item">
              <label for="password" class="visually-hidden">Password</label>
              <input
                type="password"
                id="password"
                placeholder="Password"
                required
              />
              <span class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-lock-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"
                  />
                </svg>
              </span>
            </li>
            <li class="single-form-item">
              <label for="password2" class="visually-hidden">Password</label>
              <input
                type="password"
                id="password2"
                placeholder="Re enter Password"
                required
              />
              <span class="icon"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-lock-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"
                  />
                </svg>
              </span>
            </li>
          </ul>
          <Link to="/fp" class="forgot-link">Forgot Password?</Link>

          <button class="button-login" type="submit" id="submit"
            >Create now</button
          >
        </form>
      </div>

      <div class="create-account-text text-center pb-5">
        Have an account?
        <Link to="/login" class="btn--color-radical-red">Login now</Link>
      </div>
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->
</main>
